import { definedMapWithDefault } from "./Support";

const featureFlagsKey = "featureFlags";

const defaultFlags = {
    debugPrint: false,
    forceStaging: false,
    useProductionDatabase: false,
    saveSample: false,
    showExperimental: true,
    halloween: false,
    useLocalPageMetadataService: false,
    debugBrowserReload: false,
    injectLocalDatastorePersistenceFaults: false,
    injectFileUploadFaults: false,
    logStorageController: false,
    usePlayerCriticalContainer: false,
    usePlayerSmallContainer: false,
    usePlayerLargeContainer: false,
    useBuilderSmallContainer: false,
    useBuilderLargeContainer: false,
    useFunctionsProxy: false,
    useBuilderFunctionsProxy: false,
    visualizeComputationGraph: false,
    notebooks: false,
    useFirestorePersistence: false,
    stallAppSaver: false,
};

type FeatureFlags = typeof defaultFlags;
type FeatureFlagName = keyof FeatureFlags;

interface FeatureFlagStorage {
    load(key: string, defaultFlags: FeatureFlags): FeatureFlags;
    save(key: string, flags: FeatureFlags): void;
}

let storage: FeatureFlagStorage | undefined;

let featureFlags: FeatureFlags | undefined;

function getFlags(): FeatureFlags {
    if (featureFlags === undefined) {
        featureFlags = definedMapWithDefault(storage, defaultFlags, s => s.load(featureFlagsKey, defaultFlags));
    }
    return featureFlags;
}

function saveFlags(): void {
    if (storage === undefined) return;
    storage.save(featureFlagsKey, getFlags());
}

export function getFeatureFlag(name: FeatureFlagName): boolean {
    const flags = getFlags();
    if (flags[name] === undefined) {
        flags[name] = defaultFlags[name];
        saveFlags();
    }
    return flags[name];
}

export function initFeatureFlags(s: FeatureFlagStorage, setGlobal: (name: string, value: unknown) => void): void {
    if (storage !== undefined) return;

    storage = s;

    for (const k of Object.keys(defaultFlags) as (keyof FeatureFlags)[]) {
        setGlobal(`setFeatureFlag${k.substring(0, 1).toUpperCase()}${k.substring(1)}`, (flag: boolean = true) => {
            const flags = getFlags();
            flags[k] = flag;
            saveFlags();
        });
    }

    setGlobal("resetFeatureFlags", () => {
        featureFlags = defaultFlags;
        saveFlags();
    });

    setGlobal("getFeatureFlags", getFlags);
}
